module.exports = function(app) {
	"use strict";
  app
  .directive('characterCount',characterCount);
	characterCount.$inject = ['config','$compile'];
  function characterCount(config,$compile) {
    return {
        restrict: 'A',
		scope: {
		    ngModel: '=',
            decode:'='
		},
        link: function(scope, element, attrs, ngModel) {
            var html = '<div class="character-count" ng-class="{\'warning\': characterCountLength<=limitCharacter && characterCountLength>limitCharacter-warningLimitCharacter, \'danger\': characterCountLength>limitCharacter || characterCountLength<limitCharacterMin}" ng-show="characterCountLength > 0">{{characterCountLength}}</div>';
            if(attrs.limitCharacter) {
                scope.limitCharacter = parseInt(attrs.limitCharacter);
            } else {
                scope.limitCharacter = config.limitCharacter
            }
            if(attrs.limitCharacterMin) {
                scope.limitCharacterMin = parseInt(attrs.limitCharacterMin)
            } else {
                scope.limitCharacterMin = config.limitCharacterMin;
            }
            if(attrs.warningLimitCharacter) {
                scope.warningLimitCharacter = parseInt(attrs.warningLimitCharacter)
            } else {
                scope.warningLimitCharacter = 30
            }
            if(attrs.category =="bbc") {
                scope.limitCharacter = 1000;   
            }
            if(attrs.stopTyping) {
                scope.stopTyping = parseInt(attrs.stopTyping)
                angular.element(element).on("keypress", function(e) {
                    if (scope.ngModel && scope.ngModel.length == scope.stopTyping) e.preventDefault();
                });
            }
            element.after($compile(html)(scope));
            scope.$watch(function () {
                return scope.ngModel;
            }, function(newValue) {
                if (newValue === null || newValue === undefined) return;
                if(scope.decode) {
                    scope.characterCountLength = newValue.replace(/"/g, '&quot;').length;
                } else {
                    scope.characterCountLength = newValue.length;
                }
                if(attrs.exceedName) {
                    if(scope.characterCountLength>scope.limitCharacter) {
                        if(attrs.characterCount) {
                            scope.$parent['vm'+attrs.characterCount][attrs.exceedName + 'Exceed'] = true;
                        } else {
                            scope.$parent[attrs.exceedName + 'Exceed'] = true
                        }
                    } else {
                        if(attrs.characterCount) {
                            scope.$parent['vm'+attrs.characterCount][attrs.exceedName + 'Exceed'] = false;
                        } else {
                            scope.$parent[attrs.exceedName + 'Exceed'] = false
                        }
                    }
                }
            }); 
        }
    };
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/characterCountDirective.js
// module id = 436
// module chunks = 0